export const churchCustomStyles = {
  content: {
    margin: "2.5rem auto 1.75rem",
    border: "0",
    borderRadius: "20px",
    position: "relative",
    top: "10px",
    display: "flex",
    flexDirection: "column",
    width: "90%",
    padding: 0,
    maxWidth: "85.625rem",
    inset: 0,
    overflowX: "hidden",
    right: 0,
    left: 0,
    bottom: 0,
  },
  overlay: {
    backdropFilter: "blur(13px)",
    webkitbackdropfilter: "blur(13px)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "20",
    display: "block",
    width: "100 %",
    height: "100 %",
    overflowX: "hidden",
    overflowY: "auto",
    outline: "0",
  },
};

export const eventCustomStyles = {
  content: {
    margin: "2.5rem auto 1.75rem",
    border: "0",
    borderRadius: "20px",
    position: "relative",
    top: "10px",
    display: "flex",
    flexDirection: "column",
    width: "90%",
    padding: 0,
    maxWidth: "85.625rem",
    inset: 0,
    overflow: "auto",
    overflowX: "hidden",
    right: 0,
    left: 0,
    bottom: 0,
  },
  overlay: {
    backdropFilter: "blur(13px)",
    webkitbackdropfilter: "blur(13px)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "20",
    display: "block",
    width: "100 %",
    height: "100 %",
    overflowX: "hidden",
    overflowY: "auto",
    outline: "0",
  },
};

export const pageEventCustomStyles = {
  content: {
    position: "relative",
    inset: 0,
    border: 0,
    background: "rgb(255, 255, 255)",
    overflow: "auto",
    borderRadius: "20px",
    outline: "none",
    padding: "0",
    margin: "2.5rem auto 1.75rem",
    display: "flex",
    flexDirection: "column",
    width: "90%",
    maxWidth: "85.625rem",
    overflowX: "hidden",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(13px)",
    zIndex: 20,
    display: "block",
    overflow: "hidden auto",
    outline: 0,
  },
};

export const pageChurchCustomStyles = {
  content: {
    position: "relative",
    inset: "0",
    border: 0,
    background: "rgb(255, 255, 255)",
    overflow: "auto",
    borderRadius: "20px",
    outline: "none",
    padding: 0,
    margin: "2.5rem auto 1.75rem",
    display: "flex",
    flexDirection: "column",
    width: "90%",
    maxWidth: "85.625rem",
    overflowX: "hidden",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(13px)",
    zIndex: 20,
    display: "block",
    overflow: "hidden auto",
    outline: 0,
  },
};
